import { FETCH_USER_GENERAL_INFO, LOGOUT } from '../constants/ActionTypes';
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from '../constants/PromiseMiddleware';

const defaultStore = {
  stations: [],
  isFetching: false

};

const weatherStations = (state = defaultStore, action) => {
  switch (action.type) {
    case LOGOUT:
      return defaultStore;

    case FETCH_USER_GENERAL_INFO:
      return { ...state };

    case FETCH_USER_GENERAL_INFO + _PENDING:
      return { ...state, isFetching: true };

    case FETCH_USER_GENERAL_INFO + _REJECTED:
      return { ...state, isFetching: false };

    // TODO: Take down the permits, for testing.
    case FETCH_USER_GENERAL_INFO + _FULFILLED:
      const wStations = action.payload.data.result.wheatherStations;

      return {
        ...state,
        stations:wStations,
        isFetching: false
      };
    default:
      return state;
  }
};

module.exports = weatherStations;



// WEBPACK FOOTER //
// ./reducers/weatherStationReducer.js